// extracted by mini-css-extract-plugin
module.exports = {"tilesArea":"_1w1L9","tile":"CnHmP","tileTitle":"_2Q3X7","tileDescription":"_3AOeX","tileIcon":"NzzTz","tileContent":"m2NZC"};